import React, { useState, FC } from "react"
import { makeStyles, MenuItem, Select, Typography } from "@material-ui/core"
import { colors } from "../../utils/theme"
import { ComponentHeaderHeight } from "../../utils/constants"
import { HeaderHeight } from "../molecules/Header"
import { useAllSchema2RecipePKsQuery } from "../../generated/graphql"
import { useGraphQLClient } from "../../hooks/useGraphQLClient"
import InsightDetail from "../organisms/InsightDetail"
import { useInsight } from "../../hooks/useInsight"

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: HeaderHeight,
    backgroundColor: colors.neutral.white,
    paddingLeft: theme.spacing(2, 3),
    flex: 1,
    maxWidth: 1440,
  },
  title: {
    color: colors.neutral.denim,
    padding: theme.spacing(2, 3),
  },
  header: {
    height: ComponentHeaderHeight,
    maxWidth: 1440,
    margin: "0 auto",
  },
  navigation: {
    height: 92,
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
    border: 0,
    backgroundColor: "transparent",
    paddingLeft: theme.spacing(3),
    outline: "none",
  },
  contentContainer: {
    display: "flex",
    flex: 1,
    width: "100%",
  },
  content: {
    maxWidth: 1440,
    padding: theme.spacing(2, 3),
  },
}))

interface InsightMetaProps {
  insightPK: number
}

export const InsightMeta: FC<InsightMetaProps> = ({ insightPK }) => {
  const insight = useInsight(insightPK)
  const item = insight?.insight_recipes_by_pk
  console.log(item)
  return (
    <>
      {item && (
        <>
          <Typography variant="h6">About This Insight:</Typography>
          <ul>
            <li>ID in database: {item.id}</li>
            <li>Owner Org ID: {item.owner_org_id}</li>
            <li>Public: {item.public ? "Yes" : "No"}</li>
            <li>Schema Version: {item.schema_version}</li>
          </ul>
          <hr />
        </>
      )}
    </>
  )
}

const InsightSelect: FC<{
  insightPK: number
  handleChange: (
    event: React.ChangeEvent<{
      value: unknown
    }>
  ) => void
}> = ({ insightPK, handleChange }) => {
  const graphqlClient = useGraphQLClient()
  const { data: allV2Recipes } = useAllSchema2RecipePKsQuery(graphqlClient)
  return (
    <Select value={insightPK} onChange={handleChange}>
      <MenuItem value={0}>PLEASE SELECT AN INSIGHT COMBO</MenuItem>
      {allV2Recipes?.insight_recipes &&
        allV2Recipes.insight_recipes.map((recipe) => (
          <MenuItem key={recipe.id} value={recipe.id}>
            {recipe.insight_combo.display_text}, {recipe.insight_combo.outcome}
          </MenuItem>
        ))}
    </Select>
  )
}

export const InsightViewer = () => {
  const classes = useStyles()

  const [insightPK, setInsightPK] = useState(0)
  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setInsightPK(event.target.value as number)
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.navigation}>
          <Typography variant="h2" className={classes.title}>
            Insight Viewer (for Schema Version 2)
          </Typography>
          <InsightSelect
            insightPK={insightPK}
            handleChange={handleSelectChange}
          />
        </div>
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <InsightMeta insightPK={insightPK} />
          <InsightDetail insightPK={insightPK} />
        </div>
      </div>
    </div>
  )
}

export default InsightViewer
